export const operatorActionTypes = {
    SET_NEW_OPERATOR: 'SET_NEW_OPERATOR'
};